// WO-33 — new-user onboarding. Everything the app imports comes from here.
import React from 'react';
import WelcomeDialog from './WelcomeDialog';
import Checklist from './Checklist';
import Tour from './Tour';
import HelpMenuInner from './HelpMenu';
import { OnboardingBoundary } from './OnboardingContext';

export { OnboardingProvider, useOnboarding, OnboardingBoundary } from './OnboardingContext';
export { default as OnboardingEmptyState } from './EmptyState';
export { default as AdminOnboardingCard } from './AdminOnboardingCard';
export { onboardingCopy } from './copy';

// The floating pieces, each isolated so one failing cannot take the others —
// or the page — down (R3).
export function OnboardingLayer() {
  return (
    <>
      <OnboardingBoundary><WelcomeDialog /></OnboardingBoundary>
      <OnboardingBoundary><Checklist /></OnboardingBoundary>
      <OnboardingBoundary><Tour /></OnboardingBoundary>
    </>
  );
}

export function HelpMenu() {
  return <OnboardingBoundary><HelpMenuInner /></OnboardingBoundary>;
}
